import { createFileRoute, Outlet } from '@tanstack/react-router';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import z from '@/lib/zod';
import { amountSearchParams } from '@/lib/filters/amount-search-params';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';

export const documentsSearchSchema = commonSearchSchema.extend({
  subTab: z.string().nullish(),
  invoiceScope: z.enum(['draft', 'sent', 'rejected', 'unpaid']).nullish(),
  direction: z.string().nullish(),
  type: z.string().nullish(),
  categoryIds: optionalSearchString(),
  /**
   * Controparte da cui filtrare la lista: la porta il link «vedi tutte» del
   * riepilogo in scheda controparte. Senza dichiararla qui zod la strippa
   * dall'URL e il filtro sparirebbe al primo refresh.
   */
  companyId: z.string().nullish(),
  toBePaid: optionalSearchBoolean(),
  issueDateFrom: optionalSearchString(),
  issueDateTo: optionalSearchString(),
  // Pannello Filtri (stessi nomi dell'API): senza dichiararli zod li
  // strippa dall'URL e il filtro sparirebbe al primo refresh — succedeva
  // già alla competenza righe.
  competenceDateFrom: optionalSearchString(),
  competenceDateTo: optionalSearchString(),
  ...amountSearchParams,
  sources: optionalSearchString(),
  hasAttachments: optionalSearchBoolean(),
  hasNote: optionalSearchBoolean(),
  debtType: optionalSearchString(),
  /** Revisione da aprire all'arrivo (deep link della notifica). */
  review: z.string().nullish(),
  /**
   * Workflow «Fatture arrivate» (sezione del pannello sul tab Acquisto e link
   * della card dashboard): stessi valori dell'API. Un valore scritto a mano
   * si scarta invece di rompere la route; gli stadi sconosciuti del CSV li
   * scarta il pannello prima di chiamare l'API.
   */
  reviewScope: z.enum(['pending', 'all']).nullish().catch(undefined),
  reviewStage: optionalSearchString(),
});

export type DocumentsSearchSchema = z.infer<typeof documentsSearchSchema>;

// La rotta legacy `/documents` non ha più una pagina propria — esiste solo
// come parent per i child route che eseguono i redirect verso gli hub
// (`/invoices`, `/delivery-notes`, `/orders`, `/payroll`, `/pa-obligations`,
// `/loans`). L'Outlet renderizza i child redirect e nient'altro.
export const Route = createFileRoute('/protected/_layout/documents/_layout')({
  validateSearch: documentsSearchSchema,
  component: Outlet,
});
